import { HttpClient, HttpErrorResponse, HttpHeaders, } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators, } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { ModalpopService } from '../modalpop.service';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-choice-subjects',
  templateUrl: './choice-subjects.component.html',
  styleUrls: ['./choice-subjects.component.scss'],
})
export class ChoiceSubjectsComponent implements OnInit {
  choiceSubForm: FormGroup;
  submitpayload: any;
  ChoiceSubSearchForm;
  courseList: any;
  list;
  Row1 = false;
  submitButton = true;
  editButton = false;
  deleteButton = false;
  showBranch = false;
  showParentBranch = false;
  showPExam = false;
  isReadonlyDelete = false;
  APIService: any;
  courseFilterList: any;
  pCourseList: any;
  pCourseFilterList: any;
  pExamCourseList: any;
  pExamCourseFilterList: any;
  PexStreamList: any;
  PexamStreamFilterList: any;
  choiceSubList: any[];
  choicesubfordelete = 0;
  dialogRef: MatDialogRef<any>;
  exStreamList2: any;
  examStreamFilterList2: any;
  sessionCoCode: any;
  exList: any;
  exFilterList: any;
  emid: any;
  subList: any;
  subFilterList: any;
  EmValue: any;
  BrName: any;
  cExamCourseList: any;
  cExamCourseFilterList: any;
  CexStreamList: any;
  CexamStreamFilterList: any;
  data: any;
  isDivShow = false;
  sessionEmId: any;
  cCourseList: any;
  cCourseFilterList: any;
  isReadonly = true;
  subButton = false;
  EmId: void;
  Str: void;
  isDisabled = false;
  isreadonly = true
  isDropdown = false
  PEmId = 0;
  seq = 1;
  islist = true;
  subenable= true;
  SessionNo: any;
  constructor(
    public umsService: UmsService,
    private fb: FormBuilder,
    private httpClient: HttpClient,
    public router: Router,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private modalPopupService: ModalpopService,
    private spinner: NgxSpinnerService
  ) { this.APIService = environment.serviceUrl; }
  ngOnInit(): void {
    if(JSON.parse(sessionStorage.getItem("session")) == null){
      this.fetchSecretData();
     
    }
    else if(JSON.parse(sessionStorage.getItem("session")) != null){
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo
    }
    this.Row1 = false;
    this.list = true;
    this.editButton = false;
    this.submitButton = true;
    this.isReadonlyDelete = false;
    this.deleteButton = false;
    this.showPExam = false;
    this.isDisabled = false;
    this.choiceSubForm = this.fb.group({
      CsSubCode: new FormControl(''),
      CsNM: new FormControl(''),
      EsCredit: new FormControl(''),
      CsEsShName: new FormControl(''),
      Marks: new FormControl(''),
      CsEsName: new FormControl(''),
      CsEmId: new FormControl(''),
      CsStrId: new FormControl(0),
      CsEsId: new FormControl(''),
      CsCode: new FormControl(''),
      CsGrp: new FormControl('', [Validators.pattern("[a-zA-z0-9-]*$")]),
      CsSeq: new FormControl(this.seq),
      CsDeAct: new FormControl(''),
      Course: new FormControl(''),
      CsSub: new FormControl(''),
      EmCode: new FormControl(''),
      EmCode1: new FormControl('', [Validators.required]),
      pCourse: new FormControl('', [Validators.required]),
      StrCode: new FormControl(''),
      CsStrId1: new FormControl('')
    });
    this.fetchPCourse();
    this.fetchCCourse();
    this.fetchTableData();
    this.choiceSubForm.controls['CsSub'].setValidators(Validators.required);
    this.choiceSubForm.controls['CsSub'].updateValueAndValidity();
  }

  fetchSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      this.SessionNo = res.projectPharam['SnNo']
      }
    );
  }
  
  getExamList() {
    this.Row1 = true
    this.submitpayload = this.choiceSubForm.value;
    this.choiceSubForm.controls['CsGrp'].setValue('ChSub');
    this.sessionEmId = sessionStorage.getItem('EmId');
    const payload = {};
    payload['CsEmId'] = parseInt(this.sessionEmId);
    if (this.submitpayload.CsStrId1 == '') {
      payload['CsStrId'] = 0;
    } else {
      payload['CsStrId'] = this.submitpayload.CsStrId1;
    }
    this.umsService.getTableDataForChoiceSub(payload).subscribe(
      (res) => {
        this.exList = res.data;
        if (res.data.length == 0) {
          this.isDivShow = false;
        } else {
          this.isDivShow = true;
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.exList = [];
        if (this.exList.length == 0) {
          this.isDivShow = false;
        } else {
          this.isDivShow = true;
        }
      }
    );
  }
  fetchPCourse() {
    this.spinner.show();
    const payload = {};
    this.umsService.getCourse(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        this.pCourseList = res.data;
        this.pCourseFilterList = this.pCourseList.slice();
      } else {
        this.spinner.hide();
      }
    });
  }
  fetchCCourse() {
    this.spinner.show();
    const payload = {};
    this.umsService.getCourse(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        this.cCourseList = res.data;
        this.cCourseFilterList = this.cCourseList.slice();
        this.clearorreset();
      } else {
        this.spinner.hide();
      }
    },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
      });
  }
  fetchExamBySelectedPCourse(id) {
    let payload1 = this.choiceSubForm.value;
    if (payload1.pCourse == payload1.Course) {
      this.choiceSubForm.controls['pCourse'].setValue('');
      this.choiceSubForm.controls['CsGrp'].setValue('');
      let data = {};
      data['message'] = 'Same Subject Setup, Select Another';
      data['title'] = 'Information';
      data['icon'] = 'fas fa-check';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
      );
    }
    else {
      this.spinner.show();
      const payload = {};
      payload['EmCoCode'] = id;
      payload['EmId'] = 0;
      this.Row1 = false
      this.umsService.getExam(payload).subscribe(
        (res) => {
          this.choiceSubForm.controls['CsGrp'].setValue('');
          this.spinner.hide();
          if (res.status) {
            this.showPExam = true;
            this.showParentBranch = false;
            this.pExamCourseList = res.data;
            this.pExamCourseFilterList = this.pExamCourseList.slice();
            sessionStorage.setItem('EmCoCode', id);
          } else {
            this.spinner.hide();
            this.showPExam = false;
          }
        }
      );
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
      }
    }
  }
  selectPStream(id) {
    this.PEmId = id;
    let payload2 = this.choiceSubForm.value;
    this.sessionCoCode = sessionStorage.getItem('EmCoCode');
    this.EmId = sessionStorage.setItem('EmId1', id)
    const payload = {};
    payload['CoCode'] = this.sessionCoCode;
    payload['EmId'] = id;
    payload['CsEmId'] = id;
    let CsStrId1Param = 0
    if (payload2.CsStrId == "") {
      CsStrId1Param = 0;
    } else {
      CsStrId1Param = payload2.CsStrId
    }
    payload['EsStrId'] = CsStrId1Param;
    this.umsService.getExamStream(payload).subscribe(
      (res) => {
        sessionStorage.setItem('EmId', id);
        if (res.status) {
          this.showParentBranch = true;
          this.islist = true;
          this.PexStreamList = res.data;
          this.PexamStreamFilterList = this.PexStreamList.slice();
        }
        else {
          this.islist = false;
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.showParentBranch = false;
        this.islist = true;
        this.PexStreamList = [];
        this.PexamStreamFilterList = this.PexStreamList.slice();
      }
    );
  }
  fetchExamBySelectedCourseChild(id) {
    this.spinner.show();
    let payload1 = this.choiceSubForm.value;
    this.subFilterList = [];
    this.cExamCourseFilterList = [];
    this.subenable = true;
   
    if (payload1.pCourse == payload1.Course) {
      this.spinner.hide();
      this.choiceSubForm.controls['Course'].setValue('');
      let data = {};
      data['message'] = 'Same Subject Setup, Select Another';
      data['title'] = 'Information';
      data['icon'] = 'fas fa-check';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
      );
    }
    else {
      this.isDisabled = true;
      this.spinner.show();
      const payload = {};
      payload['EmCoCode'] = id;
      payload['EmId'] = 0;
      this.subFilterList = [];
      this.cExamCourseFilterList = [];
      this.choiceSubForm.controls['CsSub'].setErrors(null);
    this.choiceSubForm.controls['CsSub'].clearValidators();
    this.choiceSubForm.controls['CsSub'].updateValueAndValidity();
      this.umsService.getExam(payload).subscribe(
        (res) => {
          if (res.status) {
            this.spinner.hide();
            this.showBranch = false;
            this.cExamCourseList = res.data;
            this.isDisabled = false;
            this.cExamCourseFilterList = this.cExamCourseList.slice();
            this.clearorreset();
          } else {
            this.showPExam = false;
          }
        }
      );
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.cExamCourseList = []
        this.cExamCourseFilterList = this.cExamCourseList.slice();
        this.clearorreset();
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
      }
    }
  }
  clearorreset() {
    this.choiceSubForm.controls['CsSub'].setValue('');
    this.choiceSubForm.controls['CsEsShName'].setValue('');
    this.choiceSubForm.controls['CsSubCode'].setValue('');
    this.choiceSubForm.controls['CsEsName'].setValue('');
    this.choiceSubForm.controls['CsEmId'].setValue('');
    this.choiceSubForm.controls['CsEsId'].setValue('');
    this.choiceSubForm.controls['CsCode'].setValue('');
    this.choiceSubForm.controls['CsSeq'].setValue('');
    this.choiceSubForm.controls['CsDeAct'].setValue('');
    this.choiceSubForm.controls['Marks'].setValue('');
    this.choiceSubForm.controls['EsCredit'].setValue('');
    this.choiceSubForm.controls['CsStrId'].setValue(0);
  }
  selectCStream(id) {
    const payload = {};
    payload['CoCode'] = id.EmCoCode;
    payload['EmId'] = id.EmId;
    this.isDisabled = false
    this.umsService.getExamStream(payload).subscribe(
      (res) => {
        if (res.status) {
          if (id.EmStreams == 'Y') {
            this.showBranch = true;
            this.isreadonly = true
          }
          else {
            this.showBranch = false;
            this.isreadonly = false
          }
          this.CexStreamList = res.data;
          this.CexamStreamFilterList = this.CexStreamList.slice();
          this.clearorreset();
        } else {

          this.showBranch = false;
          this.getSubjects({ EmId: id.EmId });
          this.CexStreamList = [];
          this.CexamStreamFilterList = this.CexStreamList.slice();
          this.clearorreset();
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.showBranch = false;
        this.getSubjects({ EmId: id.EmId });
        this.CexStreamList = [];
        this.CexamStreamFilterList = this.CexStreamList.slice();
        this.clearorreset();
      }
    );
  }
  getSubjects(item) {
    let payload = {};
    this.isDisabled = false
    let payload1 = this.choiceSubForm.value;
    this.EmValue = item.EmId;
    this.subenable = false;
    payload['EsEmId'] = payload1.EmCode;
    let CsStrIdParam = 0;
    if (payload1.CsStrId == "") {
      CsStrIdParam = 0;
    } else {
      CsStrIdParam = payload1.CsStrId
    }
    payload['EsStrId'] = CsStrIdParam;
    this.umsService.getExamSub(payload).subscribe((res) => {
      if (res.status) {
        this.subList = res.data;
        this.subFilterList = this.subList.slice();
      }
    },
      (ERROR: HttpErrorResponse) => {
        this.subList = [];
        this.subFilterList = this.subList.slice();
      });
  }
  submit() {
    if (this.choiceSubForm.invalid) {
      if (this.choiceSubForm.value['Course'] == '') {
        this.choiceSubForm.get('Course').markAsTouched();
        this.setValidatorC();
      }
      else {
        this.choiceSubForm.get('Course').markAsUntouched();
        this.removeValidatorC();
      }
      if (this.choiceSubForm.value['EmCode'] == '') {
        this.choiceSubForm.get('EmCode').markAsTouched();
        this.setValidatorE();
      }
      else {
        this.choiceSubForm.get('EmCode').markAsUntouched();
        this.removeValidatorE();
      }
      if (this.showBranch == true) {
        if (this.choiceSubForm.value['CsStrId'] == '') {
          this.choiceSubForm.get('CsStrId').markAsTouched();
          this.setValidatorB();
        }
        else {
          this.choiceSubForm.get('CsStrId').markAsUntouched();
          this.removeValidatorB();
        }
      }
      if (this.choiceSubForm.value['CsSub'] == '') {
        this.choiceSubForm.get('CsSub').markAsTouched();
        this.setValidatorS();
      }
      else {
        this.choiceSubForm.get('CsSub').markAsUntouched();
        this.removeValidatorS();
      }
      return;
    } else {
      this.addChoiceSubject();
    }
  }
  setValidatorC() {
    this.choiceSubForm.controls['Course'].setValidators([Validators.required]);
  }
  setValidatorE() {
    this.choiceSubForm.controls['EmCode'].setValidators([Validators.required]);
  }
  setValidatorB() {
    this.choiceSubForm.controls['CsStrId'].setValidators([Validators.required]);
  }
  setValidatorS() {
    this.choiceSubForm.controls['CsSub'].setValidators([Validators.required]);
  }
  removeValidatorC() {
    this.choiceSubForm.controls['Course'].clearValidators();
  }
  removeValidatorE() {
    this.choiceSubForm.controls['EmCode'].clearValidators();
  }
  removeValidatorB() {
    this.choiceSubForm.controls['CsStrId'].clearValidators();
  }
  removeValidatorS() {
    this.choiceSubForm.controls['CsSub'].clearValidators();
  }
  addChoiceSubject() {
    this.spinner.show();
    this.submitpayload = this.choiceSubForm.value;
    this.submitpayload.CsSeq = this.seq + 1;
    if (this.submitpayload.CsStrId1 !== '' || this.submitpayload.CsStrId1 !== undefined
      || this.submitpayload.CsStrId1 !== null) {
      this.submitpayload['CsStrId'] = this.submitpayload.CsStrId1;
    }
    if (this.submitpayload.StrCode == '' || this.submitpayload.StrCode == undefined
      || this.submitpayload.StrCode == null) {
      this.submitpayload['StrCode'] = 0;
    }
    this.submitpayload["CsEmId"] = this.choiceSubForm.value["EmCode1"]
    this.submitpayload["Course"] = this.choiceSubForm.value["pCourse"]
    this.umsService.createChoiceSubject(this.submitpayload).subscribe(
      (res) => {
        this.spinner.hide();
        if (res.status) {
          let data = {};
          data['message'] = res.message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-check';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
          sessionStorage.setItem('EmId', this.submitpayload.EmCode1);
          this.getExamList();
        } else {
          let data = {};
          data['message'] = res.message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-check';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-box-open';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
      }
    );
  }
  fetchTableData() {
    const payload = {};
    payload['CsEmId'] = sessionStorage.getItem('CsEmId');
    this.umsService.getTableDataForChoiceSub(payload).subscribe(
      (res) => {
        this.exList = res.data;
        if (res.data.length == 0) {
          this.isDivShow = false;
        } else {
          this.isDivShow = true;
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.exList = [];
        if (this.exList.length == 0) {
          this.isDivShow = false;
        } else {
          this.isDivShow = true;
        }
      }
    );
  }
  temp(e) {
    this.data = e;
  }
  getSubjectData(e) {
    this.isReadonly = false;
    this.isDisabled = false;
    let subjectpayload = this.choiceSubForm.value;
    if (subjectpayload.CsSub == '') {
      this.choiceSubForm.get('CsSub').markAsTouched();
    } else {
      this.choiceSubForm.controls['CsEsShName'].setValue(e.EsShName);
      this.choiceSubForm.controls['CsSubCode'].setValue(e.EsCode);
      this.choiceSubForm.controls['CsEsName'].setValue(e.EsName);
      this.choiceSubForm.controls['CsEmId'].setValue(subjectpayload['EmCode']);
      this.choiceSubForm.controls['CsEsId'].setValue(e.EsId);
      this.choiceSubForm.controls['StrCode'].setValue(e.StrCode);
      this.choiceSubForm.controls['CsGrp'].setValue('ChSub');
      this.choiceSubForm.controls['CsSeq'].setValue(1);
      this.choiceSubForm.controls['CsCode'].setValue(e.EsCode);
      this.choiceSubForm.controls['CsDeAct'].setValue(e.EsDeAct);
      this.choiceSubForm.controls['Marks'].setValue(e.EsExmMarks);
      this.choiceSubForm.controls['EsCredit'].setValue(e.EsCredit);
      this.choiceSubForm.controls['CsNM'].setValue(e.EsCode);
      this.choiceSubForm.controls['StrCode'].setValue(this.BrName);
    }
  }
  redirect(to): void {
    this.router.navigate([to]);
  }
  EditData(e, k) {
    if (e === 'true') {
      this.list = false;
      this.prepopulation(k);
    } else {
      this.list = true;
    }
  }
  getStr(id) {
    this.islist = false;
    this.Str = id;
  }
  prepopulation(id) {
    let pCourse = this.choiceSubForm.controls['pCourse'].value;
    let EmCode1 = this.choiceSubForm.controls['EmCode1'].value;
    let payload3 = this.choiceSubForm.value;
    let CsStrId2Param = 0;
    if (payload3.CsStrId1 == "") {
      CsStrId2Param = 0;
    } else {
      CsStrId2Param = payload3.CsStrId1
    }
    payload3['EsStrId'] = this.choiceSubForm.controls['CsStrId1'].value
    this.isReadonlyDelete = false;
    this.isReadonly = true;
    this.editButton = true;
    this.submitButton = false;
    this.deleteButton = false;
    this.isDisabled = true;
    this.isreadonly = false;
    this.isDropdown = true;
    this.islist = true;
    this.choiceSubForm = this.fb.group({
      CsSubCode: new FormControl(id.CsEsCode),
      CsNM: new FormControl(id.CsNM),
      EsCredit: new FormControl(id.EsCredit),
      CsEsShName: new FormControl(id.CsEsShName),
      Marks: new FormControl(id.Marks),
      CsEsName: new FormControl(id.CsEsName),
      CsEmId: new FormControl(id.EmCode),
      CsStrId: new FormControl(this.Str),
      CsEsId: new FormControl(id.CsEsId),
      CsCode: new FormControl(id.CsCode),
      CsGrp: new FormControl(id.CsGrp, [Validators.pattern("[a-zA-z0-9-]*$")]),
      CsSeq: new FormControl(id.CsSeq),
      CsDeAct: new FormControl(id.CsDeAct),
      Course: new FormControl(id.Course),
      CsSub: new FormControl(id.CsSub),
      EmCode: new FormControl(id.EmCode),
      EmCode1: new FormControl(EmCode1),
      pCourse: new FormControl(pCourse),
      StrCode: new FormControl(id.StrCode),
      CsStrId1: new FormControl(this.Str)
    });
  }
  Update() {
    if (this.choiceSubForm.invalid) {
      this.choiceSubForm.controls['CsSub'].setErrors(null);
      this.choiceSubForm.controls['CsSub'].clearValidators();
      this.choiceSubForm.controls['CsSub'].updateValueAndValidity()
      return;
    } else {
      this.updateChSub();
    }
  }
  updateChSub() {
    this.spinner.show();
    this.isReadonly = true
    this.isDisabled = true;
    this.submitpayload = this.choiceSubForm.value;
    this.submitpayload.CsEmId = this.PEmId;
    this.submitpayload.CsSeq = 1;
    if (this.showParentBranch == true) {
      this.submitpayload.CsStrId = this.choiceSubForm.controls['CsStrId1'].value
    }
    else {
      this.submitpayload.CsStrId = 0;
    }
    this.umsService.updateChoiceSubject(this.submitpayload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        let data = {};
        data['message'] = res.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-check';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.getExamList();
        this.choiceSubForm.controls['CsGrp'].setValue(this.submitpayload['CsGrp']);
      } else {
        let data = {};
        data['message'] = res.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.ngOnInit();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.exList = []
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Alert';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }
  deletee(e, k) {
    if (e === 'true') {
      this.list = false;
      this.prepopulationForDelete(k);
    } else {
      this.list = true;
    }
  }
  prepopulationForDelete(id) {
    let pCourse = this.choiceSubForm.controls['pCourse'].value;
    let EmCode1 = this.choiceSubForm.controls['EmCode1'].value;
    let CsStrId1 = this.choiceSubForm.controls['CsStrId1'].value;
    if (this.showParentBranch == true) {
      this.submitpayload.CsStrId = this.choiceSubForm.controls['CsStrId1'].value;
    }
    else {
      this.submitpayload.CsStrId = 0;
    }
    this.isReadonlyDelete = true;
    this.isReadonly = true;
    this.editButton = false;
    this.submitButton = false;
    this.deleteButton = true;
    this.isDisabled = true;
    this.isreadonly = true;
    this.isDropdown = true;
    this.islist = true;
    this.choiceSubForm = this.fb.group({
      CsSubCode: new FormControl(id.CsEsCode),
      CsNM: new FormControl(id.CsNM),
      EsCredit: new FormControl(id.EsCredit),
      CsEsShName: new FormControl(id.CsEsShName),
      Marks: new FormControl(id.Marks),
      CsEsName: new FormControl(id.CsEsName),
      CsEmId: new FormControl(id.EmCode),
      CsStrId: new FormControl(this.Str),
      CsEsId: new FormControl(id.CsEsId),
      CsCode: new FormControl(id.CsCode),
      CsGrp: new FormControl(id.CsGrp),
      CsSeq: new FormControl(id.CsSeq),
      CsDeAct: new FormControl(id.CsDeAct),
      Course: new FormControl(id.Course),
      CsSub: new FormControl(id.CsSub),
      EmCode: new FormControl(id.EmCode),
      EmCode1: new FormControl(EmCode1),
      pCourse: new FormControl(pCourse),
      StrCode: new FormControl(id.StrCode),
      CsStrId1: new FormControl(this.Str)
    });
  }
  DeletetheRecord() {
    const data = {};
    data['message'] = 'Are You Sure You Want To Delete This Record ?';
    data['title'] = 'Alert';
    data['icon'] = 'fa fa-question';
    this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
    this.dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        this.deletedata(this.choiceSubForm.value);
      }
    })
  }
  deletedata(id) {
    this.isReadonly = false
    this.isDropdown = false;
    this.islist = false;
    this.spinner.show();
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }), body: {
        CsSubCode: id.CsSubCode,
        CsNM: id.CsNM,
        EsCredit: id.EsCredit,
        CsEsShName: id.CsEsShName,
        Marks: id.Marks,
        CsEsName: id.CsEsName,
        CsEmId: id.EmCode1,
        CsStrId: id.CsStrId,
        CsEsId: id.CsEsId,
        CsCode: id.CsCode,
        CsGrp: id.CsGrp,
        CsSeq: id.CsSeq,
        CsDeAct: id.CsDeAct,
        Course: id.Course,
        CsSub: id.CsSub,
        EmCode: id.EmCode,
        EmCode1: id.EmCode1,
        pCourse: id.pCourse,
        StrCode: id.StrCode,
        CsStrId1: id.CsStrId1,
      },
    };
    this.httpClient.delete(this.APIService + '/masters/ExamChoiceSub', options)
      .subscribe((s) => {
        this.spinner.hide();
        let cc = [];
        cc.push(s);
        let data = {}
        data['message'] = cc[0].message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          this.Row1 = false;
          this.list = true;
          this.editButton = false;
          this.submitButton = true;
          this.isReadonlyDelete = false;
          this.deleteButton = false;
          this.showPExam = false;
          this.isDisabled = false;
          this.ngOnInit();
          this.showParentBranch = false;
          this.islist = true
          this.showBranch = false;
        });
      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {}
        data['message'] = ERROR.error.message
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.ngOnInit();
      });
  }


  new(){
    this.choiceSubForm.reset();
    this.showPExam = false;
    this.showParentBranch = false;
    this.Row1 = false;
    this.islist = true;
  }

  print(){
    let submitpayload = this.choiceSubForm.value;
    let payload1 = {}
    payload1['MenuName'] = 'Choice-Subject';
    payload1['EmId'] = submitpayload.EmCode1;
    payload1['StrId'] = submitpayload.CsStrId1;
    let jsonString = JSON.stringify(payload1)
    var filter: any;
    filter = {
      "LoginId": parseInt(sessionStorage.getItem('userId')) ? parseInt(sessionStorage.getItem('userId')) : 0,
      "RptCode": 125,
      "InstName": '',
      "InstNo": this.umsService.secretdata['ClubPartTrans'] ? this.umsService.secretdata['ClubPartTrans'] : 0,
      "ShId": '',
      "CgCode": '',
      "RollNo": '',
      "Cent": '',
      "TnCode": '',
      "EsId":  '',
      "CsNo": '',
      "PgBreak": '',
      "StrId": '',
      "StrCode": '',
      "RgNo": '',
      "UC": '',
      "Ledger": '',
      "RegnRoll": '',
      "DsCode": '',
      "CoCode": '',
      "SnNo": this.SessionNo,
      "Extra1": jsonString,
    }

    var payload: any;
    payload = filter;
    this.umsService.setData(JSON.stringify(payload));
    this.redirect('reports')
  }
  
 
}
